/* tslint:disable */
/* eslint-disable */
/**
 * Zalaris Benchmarks SuccessFactors API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Request body for bulk operations. - Omit \'ids\' or provide empty array to target all entities - Provide \'ids\' array with one or more IDs to target specific entities 
 */
export interface BulkOperationRequest {
    /**
     * Optional array of specific entity IDs to target for the operation. If not provided or empty, targets all entities. 
     */
    'ids'?: Array<string>;
}
export interface ErrorEntry {
    'code'?: string;
    'message'?: string;
}
/**
 * Generic error envelope used across services
 */
export interface ErrorResponse {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
}
/**
 * Generic filter condition used for building query filters
 */
export interface FilterCondition {
    /**
     * Field name to filter on
     */
    'field': string;
    /**
     * Operator to apply
     */
    'operator': FilterConditionOperatorEnum;
    /**
     * Value to compare against
     */
    'value': string;
    /**
     * Logical operator to chain with the next condition
     */
    'logicalOperator'?: FilterConditionLogicalOperatorEnum;
}

export const FilterConditionOperatorEnum = {
    Eq: 'eq',
    Ne: 'ne',
    Substringof: 'substringof',
    NotSubstringof: 'not substringof'
} as const;

export type FilterConditionOperatorEnum = typeof FilterConditionOperatorEnum[keyof typeof FilterConditionOperatorEnum];
export const FilterConditionLogicalOperatorEnum = {
    And: 'and',
    Or: 'or'
} as const;

export type FilterConditionLogicalOperatorEnum = typeof FilterConditionLogicalOperatorEnum[keyof typeof FilterConditionLogicalOperatorEnum];

/**
 * Wrapper for a list of filter conditions
 */
export interface MongoFilterRequest {
    'mongoFilters'?: Array<FilterCondition>;
}
export interface SuccessFactorsConfig {
    'id'?: string;
    /**
     * SuccessFactors base URL
     */
    'url': string;
    /**
     * Position endpoint path
     */
    'positionEndpoint'?: string;
    /**
     * SuccessFactors company ID
     */
    'companyId': string;
    /**
     * Username for authentication
     */
    'username': string;
    /**
     * Password (encrypted when stored)
     */
    'password'?: string;
    /**
     * Whether a password is configured
     */
    'hasPassword'?: boolean;
}
export interface TaskCreateResponse {
    'taskId': string;
}

/**
 * SuccessFactorsApi - axios parameter creator
 */
export const SuccessFactorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete SuccessFactors configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuccessFactorsConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/successfactors/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get SuccessFactors configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessFactorsConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/successfactors/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Import positions from SuccessFactors into the local database. Optionally apply MongoDB-style filters and limit the number of records. 
         * @summary Import positions from SuccessFactors with optional filters and limit (async)
         * @param {number} [top] Max number of records per page to request from SuccessFactors
         * @param {MongoFilterRequest} [mongoFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPositions: async (top?: number, mongoFilterRequest?: MongoFilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/successfactors/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mongoFilterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save SuccessFactors configuration
         * @param {SuccessFactorsConfig} successFactorsConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSuccessFactorsConfig: async (successFactorsConfig: SuccessFactorsConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'successFactorsConfig' is not null or undefined
            assertParamExists('saveSuccessFactorsConfig', 'successFactorsConfig', successFactorsConfig)
            const localVarPath = `/api/successfactors/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(successFactorsConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test SuccessFactors connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSuccessFactorsConnection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/successfactors/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload benchmarks to SuccessFactors for positions using bulk operation targeting. Use BulkOperationRequest to target all benchmarks or specific benchmark IDs. The onlyUpdatedRecords parameter filters to only upload benchmarks not previously uploaded. 
         * @summary Upload benchmarks to SuccessFactors (bulk operation, async)
         * @param {boolean} [onlyUpdatedRecords] If true, only upload benchmarks not previously uploaded or updated since last upload
         * @param {BulkOperationRequest} [bulkOperationRequest] Optional bulk operation targeting. Omit or provide empty ids array to target all benchmarks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBenchmarks: async (onlyUpdatedRecords?: boolean, bulkOperationRequest?: BulkOperationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/successfactors/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (onlyUpdatedRecords !== undefined) {
                localVarQueryParameter['onlyUpdatedRecords'] = onlyUpdatedRecords;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkOperationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuccessFactorsApi - functional programming interface
 */
export const SuccessFactorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuccessFactorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete SuccessFactors configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSuccessFactorsConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSuccessFactorsConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessFactorsApi.deleteSuccessFactorsConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get SuccessFactors configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuccessFactorsConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessFactorsConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuccessFactorsConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessFactorsApi.getSuccessFactorsConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Import positions from SuccessFactors into the local database. Optionally apply MongoDB-style filters and limit the number of records. 
         * @summary Import positions from SuccessFactors with optional filters and limit (async)
         * @param {number} [top] Max number of records per page to request from SuccessFactors
         * @param {MongoFilterRequest} [mongoFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importPositions(top?: number, mongoFilterRequest?: MongoFilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importPositions(top, mongoFilterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessFactorsApi.importPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Save SuccessFactors configuration
         * @param {SuccessFactorsConfig} successFactorsConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSuccessFactorsConfig(successFactorsConfig: SuccessFactorsConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessFactorsConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSuccessFactorsConfig(successFactorsConfig, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessFactorsApi.saveSuccessFactorsConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Test SuccessFactors connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testSuccessFactorsConnection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testSuccessFactorsConnection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessFactorsApi.testSuccessFactorsConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload benchmarks to SuccessFactors for positions using bulk operation targeting. Use BulkOperationRequest to target all benchmarks or specific benchmark IDs. The onlyUpdatedRecords parameter filters to only upload benchmarks not previously uploaded. 
         * @summary Upload benchmarks to SuccessFactors (bulk operation, async)
         * @param {boolean} [onlyUpdatedRecords] If true, only upload benchmarks not previously uploaded or updated since last upload
         * @param {BulkOperationRequest} [bulkOperationRequest] Optional bulk operation targeting. Omit or provide empty ids array to target all benchmarks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadBenchmarks(onlyUpdatedRecords?: boolean, bulkOperationRequest?: BulkOperationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadBenchmarks(onlyUpdatedRecords, bulkOperationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuccessFactorsApi.uploadBenchmarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuccessFactorsApi - factory interface
 */
export const SuccessFactorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuccessFactorsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete SuccessFactors configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSuccessFactorsConfig(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSuccessFactorsConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get SuccessFactors configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuccessFactorsConfig(options?: RawAxiosRequestConfig): AxiosPromise<SuccessFactorsConfig> {
            return localVarFp.getSuccessFactorsConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * Import positions from SuccessFactors into the local database. Optionally apply MongoDB-style filters and limit the number of records. 
         * @summary Import positions from SuccessFactors with optional filters and limit (async)
         * @param {number} [top] Max number of records per page to request from SuccessFactors
         * @param {MongoFilterRequest} [mongoFilterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPositions(top?: number, mongoFilterRequest?: MongoFilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskCreateResponse> {
            return localVarFp.importPositions(top, mongoFilterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save SuccessFactors configuration
         * @param {SuccessFactorsConfig} successFactorsConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSuccessFactorsConfig(successFactorsConfig: SuccessFactorsConfig, options?: RawAxiosRequestConfig): AxiosPromise<SuccessFactorsConfig> {
            return localVarFp.saveSuccessFactorsConfig(successFactorsConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test SuccessFactors connection
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSuccessFactorsConnection(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.testSuccessFactorsConnection(options).then((request) => request(axios, basePath));
        },
        /**
         * Upload benchmarks to SuccessFactors for positions using bulk operation targeting. Use BulkOperationRequest to target all benchmarks or specific benchmark IDs. The onlyUpdatedRecords parameter filters to only upload benchmarks not previously uploaded. 
         * @summary Upload benchmarks to SuccessFactors (bulk operation, async)
         * @param {boolean} [onlyUpdatedRecords] If true, only upload benchmarks not previously uploaded or updated since last upload
         * @param {BulkOperationRequest} [bulkOperationRequest] Optional bulk operation targeting. Omit or provide empty ids array to target all benchmarks.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadBenchmarks(onlyUpdatedRecords?: boolean, bulkOperationRequest?: BulkOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskCreateResponse> {
            return localVarFp.uploadBenchmarks(onlyUpdatedRecords, bulkOperationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuccessFactorsApi - object-oriented interface
 */
export class SuccessFactorsApi extends BaseAPI {
    /**
     * 
     * @summary Delete SuccessFactors configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSuccessFactorsConfig(options?: RawAxiosRequestConfig) {
        return SuccessFactorsApiFp(this.configuration).deleteSuccessFactorsConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get SuccessFactors configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSuccessFactorsConfig(options?: RawAxiosRequestConfig) {
        return SuccessFactorsApiFp(this.configuration).getSuccessFactorsConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Import positions from SuccessFactors into the local database. Optionally apply MongoDB-style filters and limit the number of records. 
     * @summary Import positions from SuccessFactors with optional filters and limit (async)
     * @param {number} [top] Max number of records per page to request from SuccessFactors
     * @param {MongoFilterRequest} [mongoFilterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importPositions(top?: number, mongoFilterRequest?: MongoFilterRequest, options?: RawAxiosRequestConfig) {
        return SuccessFactorsApiFp(this.configuration).importPositions(top, mongoFilterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save SuccessFactors configuration
     * @param {SuccessFactorsConfig} successFactorsConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public saveSuccessFactorsConfig(successFactorsConfig: SuccessFactorsConfig, options?: RawAxiosRequestConfig) {
        return SuccessFactorsApiFp(this.configuration).saveSuccessFactorsConfig(successFactorsConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test SuccessFactors connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public testSuccessFactorsConnection(options?: RawAxiosRequestConfig) {
        return SuccessFactorsApiFp(this.configuration).testSuccessFactorsConnection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload benchmarks to SuccessFactors for positions using bulk operation targeting. Use BulkOperationRequest to target all benchmarks or specific benchmark IDs. The onlyUpdatedRecords parameter filters to only upload benchmarks not previously uploaded. 
     * @summary Upload benchmarks to SuccessFactors (bulk operation, async)
     * @param {boolean} [onlyUpdatedRecords] If true, only upload benchmarks not previously uploaded or updated since last upload
     * @param {BulkOperationRequest} [bulkOperationRequest] Optional bulk operation targeting. Omit or provide empty ids array to target all benchmarks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadBenchmarks(onlyUpdatedRecords?: boolean, bulkOperationRequest?: BulkOperationRequest, options?: RawAxiosRequestConfig) {
        return SuccessFactorsApiFp(this.configuration).uploadBenchmarks(onlyUpdatedRecords, bulkOperationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



